<template>
  <div class="relative shrink-0" :style="{ width: svgSize + 'px', height: svgSize + 'px' }">
    <svg
      :width="svgSize"
      :height="svgSize"
      class="absolute top-0 left-0 -rotate-90"
      aria-hidden="true"
    >
      <circle
        :cx="svgSize / 2"
        :cy="svgSize / 2"
        :r="radius"
        :stroke="NEUTRAL_RING_COLOR"
        :stroke-width="strokeWidth"
        fill="none"
      />
      <circle
        v-if="npsScore != null"
        :cx="svgSize / 2"
        :cy="svgSize / 2"
        :r="radius"
        :stroke="color"
        :stroke-width="strokeWidth"
        fill="none"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
        stroke-linecap="round"
      />
    </svg>
    <ProtectedAvatar
      :src="resolvedAvatar"
      :size="size"
      class="absolute"
      :style="{ top: strokeWidth + 'px', left: strokeWidth + 'px' }"
    >
      <slot>
        <img
          src="@/assets/icons/doctorAvatar.svg"
          alt="Avatar do médico"
          class="w-full h-full rounded-full object-cover"
        />
      </slot>
    </ProtectedAvatar>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { classifyNpsScore, NEUTRAL_RING_COLOR } from '@/utils/nps'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from './ProtectedAvatar.vue'

const props = withDefaults(
  defineProps<{
    /** NPS agregado na escala -100..100; null (sem avaliações) exibe anel neutro. */
    npsScore?: number | null
    avatarUrl?: string | null
    size?: number
    strokeWidth?: number
  }>(),
  { npsScore: null, avatarUrl: null, size: 40, strokeWidth: 6 }
)

const resolvedAvatar = computed(() => resolveAvatarSrc(props.avatarUrl))

const radius = computed(() => props.size / 2 + props.strokeWidth / 2)
const svgSize = computed(() => radius.value * 2 + props.strokeWidth)
const circumference = computed(() => 2 * Math.PI * radius.value)

const clampedScore = computed(() => {
  if (props.npsScore == null) return 0
  return Math.min(100, Math.max(0, (props.npsScore + 100) / 2))
})
const offset = computed(() => circumference.value * (1 - clampedScore.value / 100))
const color = computed(() =>
  props.npsScore == null ? NEUTRAL_RING_COLOR : classifyNpsScore(props.npsScore).color
)
</script>
